import { useRef, useState } from "react";
import { FileUp, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export const ArtworkUploader = ({ files, onChange, max = 10, testId = "artwork-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (list) => {
    setBusy(true);
    const added = [];
    for (const f of Array.from(list).slice(0, max - files.length)) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post("/uploads/artwork", fd);
        added.push(data);
      } catch (e) {
        toast.error(`${f.name}: ${errMsg(e)}`);
      }
    }
    onChange([...files, ...added]);
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div data-testid={testId}>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy || files.length >= max}
        onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); upload(e.dataTransfer.files); }}
        className="flex w-full flex-col items-center gap-2 rounded-xl border-2 border-dashed border-[#2563EB]/50 bg-[#2563EB]/5 px-6 py-8 text-center transition-colors duration-200 hover:border-[#E5202A] hover:bg-[#E5202A]/5"
        data-testid={`${testId}-dropzone`}>
        {busy ? <Loader2 className="h-8 w-8 animate-spin text-[#E5202A]" /> : <FileUp className="h-8 w-8 text-[#E5202A]" />}
        <span className="font-display text-lg font-bold uppercase">{busy ? "Uploading..." : "Upload logo / design files"}</span>
        <span className="text-xs text-slate-400">PNG, JPG, PDF, AI, EPS, SVG, PSD · up to 25 MB each · drag & drop or tap</span>
      </button>
      <input ref={ref} type="file" multiple hidden onChange={(e) => upload(e.target.files)} data-testid={`${testId}-input`}
        accept=".png,.jpg,.jpeg,.gif,.webp,.svg,.pdf,.ai,.eps,.psd,.tif,.tiff,.heic" />
      {files.length > 0 && (
        <ul className="mt-3 space-y-2">
          {files.map((f, i) => (
            <li key={f.path} className="flex items-center justify-between rounded-lg bg-white/5 px-3 py-2 text-sm" data-testid={`${testId}-file-${i}`}>
              <span className="truncate">{f.filename}</span>
              <button type="button" onClick={() => onChange(files.filter((x) => x.path !== f.path))} className="text-slate-400 hover:text-[#E5202A]" data-testid={`${testId}-remove-${i}`}><X className="h-4 w-4" /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
